import React from 'react';
import {Button} from 'antd';
import {
	DeleteOutlined,
	EditOutlined,
	FolderAddOutlined,
	ImportOutlined,
	PlusOutlined,
} from '@ant-design/icons';

type Props = {
	canAdd: boolean;
	canEdit: boolean;
	canDelete: boolean;
	onCreateProject: () => void;
	onAddFolder: () => void;
	onAddDiagram: () => void;
	onImport: () => void;
	onEdit: () => void;
	onDelete: () => void;
	importLoading?: boolean;
	deleting?: boolean;
};

const WorkspaceToolbar: React.FC<Props> = ({
	canAdd,
	canEdit,
	canDelete,
	onCreateProject,
	onAddFolder,
	onAddDiagram,
	onImport,
	onEdit,
	onDelete,
	importLoading = false,
	deleting = false,
}) => {
	const createTitle = canAdd ? 'Добавить диаграмму' : 'Создать проект';

	return (
		<div className="workspace-toolbar-actions">
			<Button
				type="primary"
				icon={<PlusOutlined />}
				title={createTitle}
				aria-label={createTitle}
				onClick={canAdd ? onAddDiagram : onCreateProject}
			/>
			<Button
				icon={<FolderAddOutlined />}
				title="Добавить папку"
				aria-label="Добавить папку"
				disabled={!canAdd}
				onClick={onAddFolder}
			/>
			<Button
				icon={<ImportOutlined />}
				title="Импорт"
				aria-label="Импорт"
				disabled={!canAdd}
				loading={importLoading}
				onClick={onImport}
			/>
			<Button
				icon={<EditOutlined />}
				title="Редактировать"
				aria-label="Редактировать"
				disabled={!canEdit}
				onClick={onEdit}
			/>
			<Button
				danger
				icon={<DeleteOutlined />}
				title="Удалить"
				aria-label="Удалить"
				disabled={!canDelete}
				loading={deleting}
				onClick={onDelete}
			/>
		</div>
	);
};

export default WorkspaceToolbar;
